// A firmware version string is made of two parts: "<number> <date/time>".
// Example: "5 15JAN26 08:30" -> number "5", date/time "15JAN26 08:30".
// The number is derived from the firmware file, while the date/time is user editable.

// Matches only the editable date/time part: DDMMMYY HH:MM.
export const VERSION_DATE_TIME_REGEX =
  /^(0?[1-9]|[12]\d|3[01])(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\d{2} ([01]?\d|2[0-3]):[0-5]\d$/;

export interface VersionParts {
  numberPart: string;
  dateTimePart: string;
}

// Splits a full version string into its number and date/time parts.
// Everything before the first space is treated as the number part.
export function parseVersionString(versionString: string): VersionParts {
  const trimmed = versionString.trim();
  const firstSpaceIndex = trimmed.indexOf(' ');

  if (firstSpaceIndex === -1) {
    return { numberPart: trimmed, dateTimePart: '' };
  }

  return {
    numberPart: trimmed.slice(0, firstSpaceIndex),
    dateTimePart: trimmed.slice(firstSpaceIndex + 1).trim(),
  };
}

// Joins the number and date/time parts back into a full version string.
export function composeVersionString(numberPart: string, dateTimePart: string): string {
  return `${numberPart.trim()} ${dateTimePart.trim()}`.trim();
}

// True when the date/time part matches the expected DDMMMYY HH:MM format.
export function isValidDateTimePart(dateTimePart: string): boolean {
  return VERSION_DATE_TIME_REGEX.test(dateTimePart.toUpperCase());
}

// Builds the current date/time in DDMMMYY HH:MM format, used as a prefill default.
export function currentDateTimePart(now: Date = new Date()): string {
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  const day = String(now.getDate()).padStart(2, '0');
  const month = months[now.getMonth()];
  const year = String(now.getFullYear()).slice(-2);
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  return `${day}${month}${year} ${hours}:${minutes}`;
}
